export default __webpack_public_path__ + "media/images/christmas-cabin-logo-9520459fa1a0f0796f3af4f7026705a8.svg";